import { WorkplaceHighlightType } from "./constants";

export type WorkplaceHighlightItem =
  | { type: WorkplaceHighlightType.CHARTING_SOFTWARE; value: string }
  | { type: WorkplaceHighlightType.AM_PATIENTS_PER_WORKER; value: string }
  | { type: WorkplaceHighlightType.PM_PATIENTS_PER_WORKER; value: string }
  | { type: WorkplaceHighlightType.NOC_PATIENTS_PER_WORKER; value: string }
  | {
      type: WorkplaceHighlightType.QUALIFICATION_PATIENTS_PER_WORKER;
      value: {
        qualification: string;
        ratios: Array<{ period: string; value: string }>;
      };
    }
  | { type: WorkplaceHighlightType.CANCELLATION_PAYOUT; value: number }
  | { type: WorkplaceHighlightType.WELL_SUPPLIED }
  | { type: WorkplaceHighlightType.DRESS_CODE }
  | { type: WorkplaceHighlightType.BREAKS }
  | { type: WorkplaceHighlightType.EXTRA_TIME_PAY }
  | { type: WorkplaceHighlightType.INDEPENDENT_CONTRACTOR_BADGE_REQUIRED }
  | { type: WorkplaceHighlightType.CANCELLATION_PROTECTION }
  | { type: WorkplaceHighlightType.LATE_CLOCK_OUT };

export function getWorkplaceHighlightLabel(
  highlightItem: WorkplaceHighlightItem,
  mandatoryBreakDurationInMinutes: number
): string {
  switch (highlightItem.type) {
    case WorkplaceHighlightType.CHARTING_SOFTWARE: {
      return `${highlightItem.value} software`;
    }

    case WorkplaceHighlightType.AM_PATIENTS_PER_WORKER: {
      return `AM ~${highlightItem.value} patients per worker`;
    }

    case WorkplaceHighlightType.PM_PATIENTS_PER_WORKER: {
      return `PM ~${highlightItem.value} patients per worker`;
    }

    case WorkplaceHighlightType.NOC_PATIENTS_PER_WORKER: {
      return `NOC ~${highlightItem.value} patients per worker`;
    }

    case WorkplaceHighlightType.CANCELLATION_PAYOUT: {
      return `Cancellation payout <${highlightItem.value}hr`;
    }

    case WorkplaceHighlightType.WELL_SUPPLIED: {
      return "Well supplied";
    }

    case WorkplaceHighlightType.DRESS_CODE: {
      return "Dress code";
    }

    case WorkplaceHighlightType.BREAKS: {
      return `Mandatory ${mandatoryBreakDurationInMinutes} minute break`;
    }

    case WorkplaceHighlightType.EXTRA_TIME_PAY: {
      return "Extra time pay";
    }

    case WorkplaceHighlightType.QUALIFICATION_PATIENTS_PER_WORKER: {
      const { qualification, ratios } = highlightItem.value;

      if (ratios.length === 1) {
        return `Patients per ${qualification} (${ratios[0].period} Shift): ~${ratios[0].value}`;
      }

      // Using \u00A0 (non-breaking space) ensures period and value (e.g., "AM ~5") stay on the same line
      return `Patients per ${qualification}: ${ratios
        .map((ratio) => `${ratio.period}\u00A0~${ratio.value}`)
        .join(", ")}`;
    }

    case WorkplaceHighlightType.INDEPENDENT_CONTRACTOR_BADGE_REQUIRED: {
      return "Badge required";
    }

    case WorkplaceHighlightType.CANCELLATION_PROTECTION: {
      return "Cancellation Protection";
    }

    case WorkplaceHighlightType.LATE_CLOCK_OUT: {
      return "Late clock-out rules";
    }

    default: {
      // This is a safety check to ensure that all workplace highlight types are handled
      highlightItem satisfies never;
      return "";
    }
  }
}
